<template>
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content slip_out_animation">
          <div class="type-title">公司简介</div>
          <div class="video-content">
            <video
              controls
              src="https://player.alicdn.com/video/editor.mp4"
            ></video>
          </div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">文字简介</div>
          <div class="company-content">
            贵州天之源环保科技发展有限公司成立于2019年04月19日，
            注册地位于贵州省贵阳市花溪区燕楼镇燕楼村八组十八号，环保技术开发，环保工程咨询；
            环境影响评价；生态环境材料、新能源材料、超细粉体材料、光机电精密分析仪器、循环技术的研究、开发及高新技术咨询与服务；
            普通货运（不含危险品）；仓储经营与服务；超细镍粉、超细钴粉的生产、销售，固体废物回收、处置与销售；
            报废机动车回收、拆解；报废机动车回用件销售；废旧物资回收；
            再生资源开发、利用及销售废旧金属；塑料回收、破碎、加工；金属材料、冶金炉料等等
            贵州天之源环保科技发展有限公司成立于2019年04月19日，
            注册地位于贵州省贵阳市花溪区燕楼镇燕楼村八组十八号，环保技术开发，环保工程咨询；
            环境影响评价；生态环境材料、新能源材料、超细粉体材料、光机电精密分析仪器、循环技术的研究、开发及高新技术咨询与服务；
            普通货运（不含危险品）；仓储经营与服务；超细镍粉、超细钴粉的生产、销售，固体废物回收、处置与销售；
            报废机动车回收、拆解；报废机动车回用件销售；废旧物资回收；
            再生资源开发、利用及销售废旧金属；塑料回收、破碎、加工；金属材料、冶金炉料等等
            贵州天之源环保科技发展有限公司成立于2019年04月19日，
            注册地位于贵州省贵阳市花溪区燕楼镇燕楼村八组十八号，环保技术开发，环保工程咨询；
            环境影响评价；生态环境材料、新能源材料、超细粉体材料、光机电精密分析仪器、循环技术的研究、开发及高新技术咨询与服务；
            普通货运（不含危险品）；仓储经营与服务；超细镍粉、超细钴粉的生产、销售，固体废物回收、处置与销售；
            报废机动车回收、拆解；报废机动车回用件销售；废旧物资回收；
            再生资源开发、利用及销售废旧金属；塑料回收、破碎、加工；金属材料、冶金炉料等等
          </div>
        </div>
      </div>
      <div class="right" :style="'height:' + screenHeight">
        <div class="slip_in_animation">
          <div class="right-content slip_in_animation">
            <div class="type-title">公司资质</div>
            <div class="right-top">
              <div id="swipercom">
                <div class="swiper-container" id="swiperIndex">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img
                        src="	https://img02.mockplus.cn/image/2023-03-15/1cec1380-c310-11ed-b531-9faab7346306.png"
                        alt=""
                      />
                    </div>

                    <div class="swiper-slide">
                      <img
                        src="		https://img02.mockplus.cn/image/2023-03-15/19fe1b50-c310-11ed-a73d-c7636bd43f12.png"
                        alt=""
                      />
                    </div>

                    <div class="swiper-slide">
                      <img
                        src="	https://img02.mockplus.cn/image/2023-03-15/1cec1380-c310-11ed-b531-9faab7346306.png"
                        alt=""
                      />
                    </div>
                    <div class="swiper-slide">
                      <img
                        src="	 https://img02.mockplus.cn/image/2023-03-15/19fe1b50-c310-11ed-a73d-c7636bd43f12.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-content slip_in_animation">
            <div class="type-title">处理能力</div>
            <div class="right-content-center" >
              <div>医废</div>
              <div>10万吨/年</div>
            </div>
            <div class="right-content-center" >
              <div>电废</div>
              <div>200万台/年</div>
            </div>
            <div class="right-content-center">
              <div>汽废</div>
              <div>5000台/年</div>
            </div>
          </div>
          <div class="right-content slip_in_animation">
            <div class="type-title">工厂人员</div>
            <div
              class="right-bottom-content">
              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">高级工程师</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">安全检测员</div>
                <div class="right-bottom-content-item-number">3人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">分解员</div>
                <div class="right-bottom-content-item-number">110人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">运输员</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">高级管理员</div>
                <div class="right-bottom-content-item-number">3人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">高级工程师</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">安全检测员</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">分解员</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">运输员</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>

              <div class="right-bottom-content-item">
                <div class="right-bottom-content-item-title">高级管理员</div>
                <div class="right-bottom-content-item-number">10人</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";

export default {
  name: "indexModel",
  props: ["screenHeight", "scroolheight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
      scroolleftheight: "",
      scroolrightheight: "",
    };
  },
  mounted() {

    new Swiper("#swiperIndex", {
      //配置分页器内容
      loop: true, // 循环模式选项
      pagination: {
        el: ".swiper-pagination", //换页器与哪个标签关联
        clickable: true, //分页器是否可以点击
      },
      autoplay: {
        dalay: 3000,
        pauseOnMouseEnter: true,
      },
    });
    this.getNowTime();
  },
  methods: {
    getNowTime() {
      let speed = 1000;
      let that = this;
      let theNowTime = function () {
        that.nowTime = that.timeNumber();
      };
      setInterval(theNowTime, speed);
    },
    timeNumber() {
      let today = new Date();
      let date =
        today.getFullYear() +
        "-" +
        this.twoDigits(today.getMonth() + 1) +
        "-" +
        this.twoDigits(today.getDate());
      let time =
        this.twoDigits(today.getHours()) +
        ":" +
        this.twoDigits(today.getMinutes()) +
        ":" +
        this.twoDigits(today.getSeconds());
      return date + "  " + time;
    },
    twoDigits(val) {
      if (val < 10) return "0" + val;
      return val;
    },
  },
};
</script>
  <style scoped>
::-webkit-scrollbar {
  width: 0px;
}
#swipercom {
  width: 95%;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  padding-bottom: 0px;
}
#swiperIndex.swiper-container {
  width: 100%;
  height: auto;
}
#swiperIndex.swiper-container .swiper-slide img {

  width: 100%;
}
.swiper-pagination-bullet-active {
  background-color: orangered;
}
.iframe {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}

.head .title {
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 32px;
  padding-top: 15px;
}
.head .nowtime {
  color: #fff;
  position: absolute;
  right: 30px;
  top: 30px;
}

.main .left,
.main .right {
  width: 21.5vw;
  /* width: 510px; */
/* height: 900px !important; */
  /* background: rgba(17,47,107, 0.6); */
  background: rgba(19, 35, 97, .9);
  overflow: hidden;
  border: 1px solid;
border-image: linear-gradient(0deg, #63A3FF, #B6DCFF, #72BEFF) 1 1;
}
.main .left {
  float: left;
  /* margin-left: 20px; */
  margin-left: 44px;
}
.main .right {
  float: right;
  /* margin-right: 20px; */
  margin-right: 44px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main .left .left-content .video-content {
  width: 100%;
}

.main .left .left-content .video-content video {
  width: 100%;
}

.main .left .left-content .company-content {
  line-height: 30px;
  font-size: 18px;
  height: 35vh;
  padding-bottom:30px ;
  box-sizing: border-box;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

.main .right .right-content {
  padding: 15px 20px;
  color: #fff;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, .3);
  padding: 7.5px;
  padding-left: 15px;
}
.main .right .right-content div:last-child{
  border-bottom:0px;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 18vh;
  font-size: 18px;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  padding-bottom: 7px;
  margin-bottom: 7px;
  padding-left: 20px;
  /* border-bottom: 1px rgb(55, 51, 51) dotted; */
  border-bottom: 1px solid rgba(255, 255, 255, .3);
  padding: 7.5px;
  padding-left: 15px;
}
.main .right .right-content .right-bottom-content .right-bottom-content-item:last-child{
  border-bottom: 0px;
} 

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
</style>
  